module.exports = __webpack_public_path__ + "img/erlend-simensen-p.0113c295.webp";